import React, { Component } from 'react';

class EmailSection extends Component {
  state = {};

  render() {
    return (
      <div className="bg-gray-100 py-8" id="email-signup">
        <div className="container">
          <div className="flex items-center flex-col">
            <h2 className="font-sans text-shop-dark-green mb-2 text-2xl">
              Join the beta!
            </h2>
            <p className="font-sans text-gray-500 mb-8">
              ShopFeedback will be launching fall 2019!
            </p>
          </div>
          <div id="mc_embed_signup" className="flex flex-row justify-center">
            <form
              action="https://tinyfeedback.us12.list-manage.com/subscribe/post?u=3db69dd29cb44eeb4cf072da8&amp;id=9ef8321127"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate w-full md:w-1/2"
              target="_blank"
              noValidate
            >
              <div id="mc_embed_signup_scroll">
                {/* <label for="mce-EMAIL">Subscribe to our mailing list</label> */}
                <div className="flex content-center justify-center">
                  <input
                    type="email"
                    name="EMAIL"
                    className="appearance-none border rounded-tl rounded-bl w-full py-2 px-3 text-gray-500-darker"
                    id="mce-EMAIL"
                    placeholder="email address"
                    required
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                  />
                  <div
                    style={{ position: 'absolute', left: -5000 }}
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_3db69dd29cb44eeb4cf072da8_9ef8321127"
                      tabIndex="-1"
                      value=""
                    />
                  </div>
                  <input
                    type="submit"
                    value="Subscribe"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    className="bg-shop-light-green border font-sans border-shop-light-green text-shop-dark-green py-2 px-4 rounded-tr rounded-br"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="flex justify-center">
            <p className="text-center font-sans text-gray-500 italic text-xs mt-4 w-full md:w-1/2">
              We hate spam. You hate spam. Your email address will be used just
              for TinyFeedback updates.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailSection;
